import { createSlice } from '@reduxjs/toolkit';
import { ccsonGameConfigs, koenigsburgGameConfigs, chessGameConfigs } from '../config/tileGameConfig';

const initialState = {
  ccsonGameConfigs,
  koenigsburgGameConfigs,
  chessGameConfigs
};

const slice = createSlice({
  name: 'gameConfig',
  initialState,
  reducers: {
    setCcsonGameConfigs: (state, action) => {
      state.ccsonGameConfigs = action.payload;
    },
    setKoenigsburgGameConfigs: (state, action) => {
      state.koenigsburgGameConfigs = action.payload;
    },
    setChessGameConfigs: (state, action) => {
      state.chessGameConfigs = action.payload;
    }
  }
});

export const gameConfigActions = slice.actions;

export default slice.reducer;
